/* global $ */

const $traveler = $('.js-traveler');
const $additionalTravelers = $('.js-additional-travelers');

const traveler = {
  initialize() {
    if ($traveler.length) {
      this.createListeners();

      this.reindexForms();
    }
  },

  createListeners() {
    $traveler.on('click', '.js-traveler-add', ({ currentTarget }) => {
      this.addForm(currentTarget);
      this.reindexForms();
    });

    $traveler.on('click', '.js-traveler-remove', ({ currentTarget }) => {
      this.removeForm(currentTarget);
      this.reindexForms();
    });
  },

  addForm(target) {
    const $currentTarget = $(target);
    const $currentForm = $currentTarget.parents('.js-traveler-form');
    const $currentFormButtonWrapper = $currentForm.find('.js-traveler-add-wrapper');
    const $newForm = $currentForm.clone();
    const $newFormFields = $newForm.find('input, select, textarea');

    $newFormFields.each((i, element) => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = false;
      } else {
        element.value = '';
      }
    });

    $currentFormButtonWrapper.hide();

    $additionalTravelers.append($newForm);
  },

  removeForm(target) {
    const $currentTarget = $(target);
    const $currentForm = $currentTarget.parents('.js-traveler-form');
    const $previousFormButton = $currentForm.prev().find('.js-traveler-add-wrapper');

    $currentForm.remove();

    if ($('.js-additional-travelers').html().trim() === '') {
      $('.js-traveler-add-wrapper').show();
      return;
    }

    $previousFormButton.show();
  },

  reindexForms() {
    const $forms = $('.js-traveler-form');
    const $formHeadingNumbers = $('.js-traveler-number');
    const attributes = ['id', 'for', 'name'];

    $forms.each((i, form) => {
      $(form).find('[id^=traveler], [for^=traveler], [name^=traveler]').each((a, element) => {
        attributes.forEach((attribute) => {
          if (element.getAttribute(attribute)) {
            element.setAttribute(attribute, element.getAttribute(attribute).replace(/traveler\[(\d+)]/, `traveler[${i}]`));
          }
        });
      });
    });

    $formHeadingNumbers.each((i, heading) => {
      $(heading).text(i + 1);
    });
  },
};

export default traveler;
